<template>
  <modal name="application-modal"
         @closed="$emit('updateComparisonData')"
         @before-close="beforeClose"
         @before-open="beforeOpen"
         style="z-index: 1001;">
    <div id="modal-header" class="w-100 px-4 py-2 position-relative"
         style="background-color:#1e7bb7">
      <div class="w-100 d-flex">
        <div class="row justify-content-center">
          <div class="col-12">
            <h4 class="text-white text-center">Կազմել Մրցույթի Հայտ</h4>
          </div>
          <!-- <div class="col-10">
            <h6 class="text-white text-center">{{ tender.name }}</h6>
          </div> -->
        </div>
      </div>
      <button type="button"
              class="close position-absolute"
              style="right: 1.25rem; top: 30%"
              @click="$modal.hide('application-modal')" aria-label="Close">
        <span aria-hidden="true" class="text-white">&times;</span>
      </button>
    </div>
    <div v-if="me.organisation" id="modal-body" class="p-4" style="overflow-x: auto; height: 85%">
      <table class="VueTables__table table table-striped table-bordered table-hover" style="overflow: hidden;">
        <thead>
            <tr>
              <th tabindex="0" title="" class="VueTables__sortable " style="position: relative;">
                  <div class="row justify-content-center">
                    <span class="VueTables__heading">Մրցույթի ծածկագիր</span>
                  </div>
                  <div class="resize-handle" style="top: 0px; right: 0px; width: 5px; position: absolute; cursor: col-resize; user-select: none; height: 92px;"></div>
              </th>
              <th tabindex="0" title="" class="VueTables__sortable ">
                  <div class="row justify-content-center">
                    <span class="VueTables__heading">Անվանում</span>
                  </div>
              </th>
              <th tabindex="0" title="" class="VueTables__sortable ">
                  <div class="row justify-content-center">
                    <span class="VueTables__heading">Պատվիրատու</span>
                  </div>
              </th>
            </tr>
        </thead>
        <tbody>
            <tr class="VueTables__row ">
              <td tabindex="0" class="">{{tender.password}}</td>
              <td tabindex="0" class="">{{tender.title}}</td>
              <td tabindex="0" class="">{{tender.organizator}}</td>
            </tr>
        </tbody>
      </table>
      <div v-if="tender.guaranteed">
        <a @click="$modal.show('guarantee-modal')" href="#" class="btn btn-primary">Դիմել երաշխիքի համար</a>
      </div>
      <div v-if="tender.is_new_beneficiari === false">
        <h5 class="pt-4">Իրական շահառուներ</h5>
        <table class="VueTables__table table table-striped table-bordered table-hover" style="overflow: hidden;">
          <thead>
              <tr>
                <th tabindex="0" title="" class="VueTables__sortable " style="position: relative;">
                    <div class="row justify-content-center">
                      <span class="VueTables__heading">{{ options.headings.name_surname }}</span>
                    </div>
                    <div class="resize-handle" style="top: 0px; right: 0px; width: 5px; position: absolute; cursor: col-resize; user-select: none; height: 92px;"></div>
                </th>
                <th tabindex="0" title="" class="VueTables__sortable ">
                    <div class="row justify-content-center">
                      <span class="VueTables__heading">{{ options.headings.armenian_card_number }}</span>
                    </div>
                </th>
                <th tabindex="0" title="" class="VueTables__sortable ">
                    <div class="row justify-content-center">
                      <span class="VueTables__heading">{{ options.headings.international_card_number }}</span>
                    </div>
                </th>
                <th tabindex="0" title="" class="VueTables__sortable ">
                    <div class="row justify-content-center">
                      <span class="VueTables__heading"></span>
                    </div>
                </th>
              </tr>
          </thead>
          <tbody>
            <tr v-for="(beneficiary, index) in realBeneficiaries" :key="index">
              <td>
                <input 
                  v-model="beneficiary.name_surname"
                  type="text"
                  class="form-control"
                >
              </td>
              <td>
                <input 
                  v-model="beneficiary.armenian_card_number"
                  type="text"
                  class="form-control"
                >
              </td>
              <td>
                <input 
                  v-model="beneficiary.international_card_number"
                  type="text"
                  class="form-control"
                >
              </td>
              <td>
                <div>
                  <div class="row d-block">
                    <div class="col-6 mb-2">
                      <button v-if="realBeneficiaries.length !== 1" @click="removeBeneficiary(index)" type="button" class="btn btn-danger">
                        <i class="fa fa-trash" aria-hidden="true"></i>
                      </button>
                    </div>
                    <div v-if="index === realBeneficiaries.length - 1" class="col-6">
                      <button @click="addBeneficiary(index)" type="button" class="btn btn-success">
                        <i class="fa fa-plus" aria-hidden="true"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else>
        <div v-if="me.organisation[0].id_card_number === '' || me.organisation[0].translations.company_type !== 'Ա/Ձ'">
          <h5 class="font-weight-bold pt-3">Տեղեկություններ պարունակող կայքէջի հղումը՝</h5>
          <input 
                  v-model="realBeneficiaries.linkInfoPage"
                  type="text"
                  class="input-st"
                  :disabled="realBeneficiaries.inputOptions === '2'"
          >
          <div class="mt-4">
            <div class="d-flex mt-3 align-items-start">
              <input type="radio" id="first" class="input-sp" name="check" value="1" v-model="realBeneficiaries.inputOptions" @change="checkOption" :checked="firstOption">
              <label class="ml-4" for="first">Մասնակիցը «Իրավաբանական անձանց պետական գրանցման, իրավաբանական անձանց ստորաբաժանումների, հիմնարկների և անհատ ձեռնարկատերերի պետական հաշվառման մասին» օրենքի հիման վրա իրական շահառուների վերաբերյալ հայտարարագիր ներկայացնելու պարտականություն ունեցող իրավաբանական անձ է և հայտը ներկայացնելու օրվա դրությամբ սահմանված կարգով պետք է իրավաբանական անձանց պետական ռեգիստրի գործակալությունում գրանցված լիներ իր իրական շահառուների վերաբերյալ տեղեկությունները։</label>
            </div>
            <div class="d-flex mt-3 align-items-start">
              <input type="radio" id="second" class="input-sp" name="check" value="2" v-model="realBeneficiaries.inputOptions" @change="checkOption" :checked="secondOption">
              <label class="ml-4" for="second">Մասնակիցը «Իրավաբանական անձանց պետական գրանցման, իրավաբանական անձանց ստորաբաժանումների, հիմնարկների և անհատ ձեռնարկատերերի պետական հաշվառման մասին» օրենքի հիման վրա իրական շահառուների վերաբերյալ հայտարարագիր ներկայացնելու պարտականություն ունեցող իրավաբանական անձ չէ, կամ եթե այդպիսի իրավաբանական անձ է սակայն հայտը ներկայացնելու օրվա դրությամբ պարտավոր չէր իրավաբանական անձանց պետական ռեգիստրի գործակալությունում գրանցել իր իրական շահառուների վերաբերյալ տեղեկություններըասնակիցը «Իրավաբանական անձանց պետական գրանցման, իրավաբանական անձանց ստորաբաժանումների, հիմնարկների և անհատ ձեռնարկատերերի պետական հաշվառման մասին» օրենքի հիման վրա իրական շահառուների վերաբերյալ հայտարարագիր ներկայացնելու պարտականություն ունեցող իրավաբանական անձ չէ, կամ եթե այդպիսի իրավաբանական անձ է սակայն հայտը ներկայացնելու օրվա դրությամբ պարտավոր չէր իրավաբանական անձանց պետական ռեգիստրի գործակալությունում գրանցել իր իրական շահառուների վերաբերյալ տեղեկությունները։</label>
            </div>
          </div>
          <div class="d_flex justify-content-end mt-5" :class="{'d-none' : showElem}">
            <button class="btn btn-primary"
              :disabled="selectedRows.length === 0"
              @click="$modal.show('new-editor-modal', {
                        action: 'save_download',
                        fileName: `real_beneficiary_declaration_form`,
                        tender: {tender, isWithProductsDetails, realBeneficiaries, selectedRows, isWithArmenianResources, workersCount, ...{type: tender.type}},
                        editorTitle: `Իրական շահառուների վերաբերյալ հայտարարագրի ձև`,
              })"
              type="button"
              style="width: fit-content"
            >Իրական շահառուների վերաբերյալ հայտարարագրի ձև</button>
            <button class="btn btn-primary ml-3"
              :disabled="selectedRows.length === 0"
              @click="$modal.show('new-editor-modal', {
                action: 'download',
                fileName: `procedure_for_filling_out_the_declaration`,
                tender: {tender, isWithProductsDetails, realBeneficiaries, selectedRows, isWithArmenianResources, workersCount, ...{type: tender.type}},
                editorTitle: `Հայտարարագրի լրացման կարգը`,
              })"
              type="button"
              style="width: fit-content">Հայտարարագրի լրացման կարգը</button>
          </div>
      </div>
      </div>

      <div v-if="tender.cpv_type === 'work'" class="row mt-5 mb-2">
        <div class="col-6">
          <div class="row">
            <div class="col-11">
              <label class="form-check-label" for="is֊with֊products-details">
                Ներկայացնել սարքեր/սարքավորումների կիրառումը
              </label>
            </div>
            <div class="col">
              <input 
                v-model="isWithProductsDetails"
                type="checkbox"
                @input="handleIsWithProductsDetails"
                :true-value="true"
                :false-value="false"
                id="is֊with֊products-details"
              >
            </div>
          </div>
        </div>
      </div>
      <div class="my-4">
        <div class="row justify-content-start">
          <div class="col-2">
            Որ չափաբաժիններին եք ցանկանում մասնակցել
          </div>
          <div class="col-4">
            <multiselect
              v-model="selectedRows"
              selectLabel="Սեղմեք enter ընտրելու համար"
              deselectLabel="Սեղմեք հեռացնելու համար"
              selectedLabel="Ընտրված է"
              :close-on-select="false"
              :allowEmpty="true"
              :searchable="true"
              :options="tender.rows"
              :multiple="true"
              :custom-label="nameWithViewId"
              placeholder="Ընտրեք չափաբաժինները"
              track-by="id"
              label="name"
            >
              <template slot="option" slot-scope="props">
                <span class="d-inline-block text-truncate" style="max-width: 370px;">{{ props.option.viewId }} {{ props.option.name }}</span>
              </template>
            </multiselect>
          </div>
        </div>
      </div>
      <!-- <v-client-table  v-if="procedure_type !== 'ELAH'" :columns="columns" v-model="selectedRows" :options="options"> -->
      <v-client-table  :columns="columns" v-model="selectedRows" :options="options">
        <div slot="id" class="d-flex justify-content-center" slot-scope="{row}">
          {{ row.viewId }}
        </div>
        <div slot="price" class="d-flex justify-content-center" slot-scope="{row, index}">
          <div class="row px-2">
            <div class="col-12" v-tooltip="tender.cpv_type !== 'service' && !row.specification && 'Լրացրեք ապրանքի տեխնիկական բնութագրերը նախքան գնային առաջարկ ներկայացնելը'">
              <input 
                v-model.number="row.value"
                :disabled="tender.cpv_type !== 'service' && !row.specification && isWithProductsDetails"
                @input="calculateByTotal(row, index-1)"
                type="text"
                min="1"
                class="form-control"
              >
            </div>
          </div>
        </div>
        <div slot="name" class="d-flex justify-content-center" slot-scope="{row, index}">
          <div class="row px-2">
            <div class="col-12">
              <input 
                v-model="row.name"
                @input="handleNameChange(row, index-1)"
                type="text"
                min="1"
                class="form-control"
              >
            </div>
          </div>
        </div>
        <div slot="products_details" class="d-flex justify-content-center" slot-scope="{row, index}">
          <button
            @click.prevent="() => {
              $modal.show('products-details-modal', {row, setProductDetails, ...{index: index-1}, ...{cpv_type: tender.cpv_type}, procedure_type})
            }"
            type="button"
            class="btn"
            :class="row.specification ? 'btn-success' : 'btn-danger' "
          >
              Լրացնել
          </button>
        </div>
        <div slot="price" class="d-flex justify-content-center" slot-scope="{row, index}">
          <div class="row px-2">
            <div class="col-12" v-tooltip="tender.cpv_type !== 'service' && !row.specification && 'Լրացրեք ապրանքի տեխնիկական բնութագրերը նախքան գնային առաջարկ ներկայացնելը'">
              <input 
                v-model.number="row.value"
                :disabled="tender.cpv_type !== 'service' && !row.specification && isWithProductsDetails"
                @input="calculateByTotal(row, index-1)"
                type="number"
                min="1"
                class="form-control"
              >
            </div>
          </div>
        </div>
        <div slot="cost" class="d-flex justify-content-center" slot-scope="{row, index}">
          <div class="row px-2">
            <div class="col-12" v-tooltip="tender.cpv_type !== 'service' && !row.firm_name && 'Լրացրեք ապրանքի ամբողջական նկարագիրը նախքան գնային առաջարկ ներկայացնելը'">
              <input 
                v-model.number="row.cost"
                :disabled="tender.cpv_type !== 'service' && !row.specification && isWithProductsDetails"
                @input="calculateByCost(row, index-1)"
                type="number"
                min="1"
                class="form-control"
              >
            </div>
          </div>
        </div>
        <div slot="profit" class="d-flex justify-content-center" slot-scope="{row, index}">
          <div class="row px-2">
            <div class="col-12" v-tooltip="tender.cpv_type !== 'service' && !row.firm_name && 'Լրացրեք ապրանքի ամբողջական նկարագիրը նախքան գնային առաջարկ ներկայացնելը'">
              <input 
                v-model.number="row.profit"
                :disabled="tender.cpv_type !== 'service' && !row.specification && isWithProductsDetails"
                @input="calculateByCost(row, index-1)"
                type="number"
                min="1"
                class="form-control"
              >
            </div>
          </div>
        </div>
        <div slot="vat" class="d-flex justify-content-center" slot-scope="{row, index}">
          <div class="row px-2">
            <div class="col-12">
              <input
                v-model="row.is_with_vat"
                :true-value="1"
                :false-value="0"
                :data-index="index-1"
                @change="handleVatSelect(row, index-1)"
                type="checkbox">
                <span class="m-2">{{row.vat}}</span>
            </div>
          </div>
        </div>
        <div slot="overall" slot-scope="{row}">
          <p class="mb-0">{{row.overall}}</p>
          <p 
            v-if="row.estimated_price > 0 && row.overall > row.estimated_price"
            class="text-danger mb-0" style="font-size: 0.7rem"
          >
            գերազանցում է նախահաշվային ընդհանուր գինը
          </p>
        </div>
        <div slot="estimated_price" class="d-flex justify-content-center" slot-scope="{row}">
          {{row.estimated_price !== null
          ?
            +row.estimated_price !== 0.00 ? row.estimated_price : "Պարտադիր բանակցություններ (15-րդ հոդվածի 6-րդ մաս)"
          :
            tender.price_file ?  'Դիտել կցված գնումների պլանից': "Բացակայում է"
          }}
          <!-- {{parseFloat(row.estimated_price)}}
          {{parseFloat(row.estimated_price) === 0}}
          {{parseFloat(row.estimated_price) !== 0}}
          {{
            parseFloat(+row.estimated_price) !== 0 ?
             row.estimated_price : tender.price_file ? 
            tender.price_file ? 'Դիտել կցված գնումների պլանից':
            "Պարտադիր բանակցություններ (15-րդ հոդվածի 6-րդ մաս)" 
            : "Բացակայում է"
          }} -->
        </div>
      </v-client-table>
      <!-- <div v-if="tender.type !== 'PAPER'" class="row mt-5 mb-2">
        <div class="col-6">
          <div class="row">
            <div class="col-11">
              <label class="form-check-label" for="is֊with֊armenian-resources">
                Հայտարարություն հայաստանյան ծագում ունեցող աշխատանքային և (կամ) արտադրական ռեսուրսների օգտագործման մասին
              </label>
            </div>
            <div class="col">
              <input 
                v-model="isWithArmenianResources"
                type="checkbox"
                :true-value="true"
                :false-value="false"
                id="is֊with֊armenian-resources"
              >
            </div>
            <div v-if="isWithArmenianResources" class="col-11">
              <label class="form-check-label" for="workers֊count">
                պայմանագիրը կատարել <the-mask v-model="workersCount" style="width: 50px" mask="###" type="text" min="1" class="d-inline form-control" id="workers֊count" /> թվով աշխատակիցների միջոցով։
              </label>
            </div>
          </div>
        </div>
      </div> -->
      <table v-if="isWithArmenianResources" class="VueTables__table table table-striped table-bordered table-hover" style="overflow: hidden;">
        <template v-for="(row, index) in selectedRows">
          <thead :key="index">
            <tr>
              <th colspan='3' style="position: relative;">
                  <div class="row justify-content-center">
                    <span>Չափաբաժնի N՝ {{ row.viewId }}</span>
                  </div>
              </th>
            </tr>
            <tr>
              <th colspan='3' style="position: relative;">
                  <div class="row justify-content-center">
                    <span>Օգտագործվելիք նյութերի</span>
                  </div>
              </th>
            </tr>
            <tr>
              <th style="position: relative;">
                  <div class="row justify-content-center">
                    <span>Անվանում</span>
                  </div>
              </th>
              <th style="position: relative;">
                  <div class="row justify-content-center">
                    <span>Քանակ</span>
                  </div>
              </th>
              <th style="position: relative;">
                  <div class="row justify-content-center">
                    <span>Գումար/դրամ</span>
                  </div>
              </th>
            </tr>
            <tr v-for="(material, materialIndex) in row.usedMaterials" :key="materialIndex">
              <td>
                <input 
                  v-model="material.name"
                  type="text"
                  class="form-control"
                >
              </td>
              <td>
                <input 
                  v-model="material.count"
                  type="text"
                  class="form-control"
                >
              </td>
              <td>
                <input 
                  v-model="material.value"
                  type="text"
                  class="form-control"
                >
              </td>
              <td>
                <div>
                  <div class="row d-block">
                    <div class="col-6 mb-2">
                      <button v-if="row.usedMaterials.length !== 1" @click="removeUsedMaterial(index, materialIndex)" type="button" class="btn btn-danger">
                        <i class="fa fa-trash" aria-hidden="true"></i>
                      </button>
                    </div>
                    <div v-if="materialIndex === row.usedMaterials.length - 1" class="col-6">
                      <button @click="addUsedMaterial(index, materialIndex)" type="button" class="btn btn-success">
                        <i class="fa fa-plus" aria-hidden="true"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </thead>
        </template>
      </table>
      <div class="row justify-content-center mb-3">
        <div class="btn-group-toggle" data-toggle="buttons">
          <label @click="confirm"  class="btn btn-success">
            <input type="checkbox" :checked="isConfirmed" autocomplete="off"> {{isConfirmed ? 'Հաստատված է' : 'Հաստատել'}}
          </label>
        </div>
      </div>
      <div v-if="isConfirmed" class="row align-items-center flex-column pt-5">
          <div v-if="tender.cpv_type === 'product'">
            <button 
              @click="$modal.show('new-editor-modal', {
                        action: 'download',
                        fileName: `application_announcement_product_appendix1`,
                        tender: {tender, isWithProductsDetails, realBeneficiaries, selectedRows, isWithArmenianResources, workersCount, ...{type: tender.type}},
                        editorTitle: `Հավելված 1`,
              })"
              type="button"
              class="btn btn-primary mr-2"
              style="width: fit-content"
            >
                <i class="fas fa-file-alt mr-1" />
                Հավելված 1
            </button>
            <button
              @click="$modal.show('new-editor-modal', {
                        action: 'download',
                        fileName: `application_announcement_product_appendix1_1`,
                        tender: {tender, isWithProductsDetails, realBeneficiaries, selectedRows, isWithArmenianResources, workersCount, ...{type: tender.type}},
                        editorTitle: `Հավելված 1.1`,
              })"
              type="button"
              class="btn btn-primary mr-2"
              style="width: fit-content"
            >
                <i class="fas fa-file-alt mr-1" />
                Հավելված 1.1
            </button>
            <button
              v-if="isWithArmenianResources"
              @click="$modal.show('new-editor-modal', {
                        action: 'download',
                        fileName: `application_announcement_product_appendix1_2`,
                        tender: {tender, isWithProductsDetails, realBeneficiaries, selectedRows, isWithArmenianResources, workersCount, ...{type: tender.type}},
                        editorTitle: `Հավելված 1.2`,
              })"
              type="button"
              class="btn btn-primary mr-2"
              style="width: fit-content"
            >
                <i class="fas fa-file-alt mr-1" />
                Հավելված 1.2
            </button>
            <button v-if="procedure_type !== 'ELAH'"
              @click="$modal.show('new-editor-modal', {
                        action: 'download',
                        fileName: `application_announcement_product_appendix2`,
                        tender: {tender, isWithProductsDetails, realBeneficiaries, selectedRows, isWithArmenianResources, workersCount, ...{type: tender.type}},
                        editorTitle: `Հավելված 2`,
              })"
              type="button"
              class="btn btn-primary"
              style="width: fit-content"
            >
                <i class="fas fa-file-alt mr-1" />
                Հավելված 2
            </button>
          </div>
          <div v-else-if="tender.cpv_type === 'service'">
            <button
              @click="$modal.show('new-editor-modal', {
                        action: 'download',
                        fileName: `application_announcement_service_appendix1`,
                        tender: {tender, isWithProductsDetails, realBeneficiaries, selectedRows, isWithArmenianResources, workersCount, ...{type: tender.type}},
                        editorTitle: `Հավելված 1`,
              })"
              type="button"
              class="btn btn-primary mr-2"
              style="width: fit-content"
            >
                <i class="fas fa-file-alt mr-1" />
                Հավելված 1
            </button>
            <button
              v-if="isWithArmenianResources"
              @click="$modal.show('new-editor-modal', {
                        action: 'download',
                        fileName: `application_announcement_service_appendix1_1`,
                        tender: {tender, isWithProductsDetails, realBeneficiaries, selectedRows, isWithArmenianResources, workersCount, ...{type: tender.type}},
                        editorTitle: `Հավելված 1.1`,
              })"
              type="button"
              class="btn btn-primary mr-2"
              style="width: fit-content"
            >
                <i class="fas fa-file-alt mr-1" />
                Հավելված 1.1
            </button>
            <button v-if="procedure_type !== 'ELAH'"
              @click="$modal.show('new-editor-modal', {
                        action: 'download',
                        fileName: `application_announcement_service_appendix2`,
                        tender: {tender, isWithProductsDetails, realBeneficiaries, selectedRows, isWithArmenianResources, workersCount, ...{type: tender.type}},
                        editorTitle: `Հավելված 2`,
              })"
              type="button"
              class="btn btn-primary"
              style="width: fit-content"
            >
                <i class="fas fa-file-alt mr-1" />
                Հավելված 2
            </button>
          </div>
          <div v-else>
            <button
              @click="$modal.show('new-editor-modal', {
                        action: 'download',
                        fileName: `application_announcement_work_appendix1`,
                        tender: {tender, isWithProductsDetails, realBeneficiaries, selectedRows, isWithArmenianResources, workersCount, ...{type: tender.type}},
                        editorTitle: `Հավելված 1`,
              })"
              type="button"
              class="btn btn-primary mr-2"
              style="width: fit-content"
            >
                <i class="fas fa-file-alt mr-1" />
                Հավելված 1
            </button>
            <button
              @click="$modal.show('new-editor-modal', {
                        action: 'download',
                        fileName: `application_announcement_work_appendix1_1`,
                        tender: {tender, isWithProductsDetails, realBeneficiaries, selectedRows, isWithArmenianResources, workersCount, ...{type: tender.type}},
                        editorTitle: `Հավելված 1.1`,
              })"
              type="button"
              class="btn btn-primary mr-2"
              style="width: fit-content"
            >
                <i class="fas fa-file-alt mr-1" />
                Հավելված 1.1
            </button>
            <button
              v-if="isWithArmenianResources"
              @click="$modal.show('new-editor-modal', {
                        action: 'download',
                        fileName: `application_announcement_work_appendix1_2`,
                        tender: {tender, isWithProductsDetails, realBeneficiaries, selectedRows, isWithArmenianResources, workersCount, ...{type: tender.type}},
                        editorTitle: `Հավելված 1.2`,
              })"
              type="button"
              class="btn btn-primary mr-2"
              style="width: fit-content"
            >
                <i class="fas fa-file-alt mr-1" />
                Հավելված 1.2
            </button>
            <button v-if="procedure_type !== 'ELAH'"
              @click="$modal.show('new-editor-modal', {
                        action: 'download',
                        fileName: `application_announcement_work_appendix2`,
                        tender: {tender, isWithProductsDetails, realBeneficiaries, selectedRows, isWithArmenianResources, workersCount, ...{type: tender.type}},
                        editorTitle: `Հավելված 2`,
              })"
              type="button"
              class="btn btn-primary"
              style="width: fit-content"
            >
                <i class="fas fa-file-alt mr-1" />
                Հավելված 2
            </button>
          </div>
          <div :class="{'d-none' : showBlock}" class="pt-3">
            <p class="text-center font-weight-bold">Հաղթելուց հետո ներկայացվող փաստաթղթեր</p>
            <button
              @click="$modal.show('submitted-documents-modal', {
                        tender: {tender, isWithProductsDetails, realBeneficiaries, selectedRows, isWithArmenianResources, workersCount, submittedDocumentData, ...{type: tender.type}, getSubmittedDocumentData},
              })"
              type="button"
              class="btn btn-primary"
              style="width: fit-content"
            >
                Հաղթելուց հետո ներկայացվող փաստաթղթեր
            </button>
          </div>
      </div>
    </div>
    <products-details-modal />
  </modal>
</template>
<script>
import { required, requiredUnless} from 'vuelidate/lib/validators'
import ProductsDetailsModal from './ProductsDetailsModal'


export default {
  name: 'ApplicationModal',
  props: ['from'],
  components: { ProductsDetailsModal},
  data () {
    return {
      submittedDocumentData: {},
      getSubmittedDocuments: {},
      secondOption: null,
      firstOption: null,
      procedure_type: null,
      showElem: true,
      showBlock: true,
      fromFavorites: false,
      applications: JSON.parse(localStorage.getItem('applications')),
      items: {},
      isConfirmed: false,
      tender: {},
      selectedRows: [],
      addToFavorite: undefined,
      isWithArmenianResources: false,
      isWithProductsDetails: true,
      workersCount: 0,
      realBeneficiaries: {
          inputOptions: '1',
          linkInfoPage : '',
          name_surname: '',
          armenian_card_number: '',
          international_card_number: '',
      },
      realBeneficiariesColumns: ['linkInfoPage', 'name_surname', 'armenian_card_number', 'international_card_number'],
      columns: ['id', 'name', 'code', 'price', 'vat', 'overall', 'estimated_price'],
      options: {
        sortable: [],
        columnsDropdown: false,
        filterByColumn: false,
        filterable: false,
        headings: {
          id: 'Չ/Հ',
          name: 'Գնման առարկա',
          code: 'CPV կոդ',
          price: 'Արժեք',
          vat: 'ԱԱՀ',
          overall: 'Ընդամենը',
          name_surname: 'Անունը Ազգանունը Հայրանունը',
          armenian_card_number: 'ՀՀ քաղաքացիների համար` նույնականացման քարտի կամ անձնագրի կամ ՀՀ օրենսդրությամբ նախատեսված անձը հաստատող փաստաթղթի տեսակը և համարը',
          international_card_number: 'Օտարերկրյա քաղաքացիների համար համապատասխան երկրի օրենսդրությամբ նախատեսված անձը հաստատող փաստաթղթի տեսակը և համարը',
          products_details: 'Ամբողջական նկարագիր',
          cost: 'Ինքնարժեք',
          profit: 'Շահույթ',
          estimated_price: 'Նախահաշվային ընդհանուր գին'
        },
        texts: {
          count:
          'Ցուցադրված է {from}֊ից {to}֊ը ընդհանուր {count} տողից|{count} տող|',
          first: 'Առաջին',
          last: 'Վերջին',
          filter: '',
          filterPlaceholder: 'Փնտրել',
          limit: '',
          page: 'Page:',
          noResults: 'Չկան ընտրված չափաբաժիններ',
          noRequest: 'խնդրում ենք ընտրել առնվազն մեկ ֆիլտեր տվյալները ներբեռնելու համար',
          filterBy: 'փնտրել ըստ {column}',
          loading: 'Բեռնվում է...',
          defaultOption: 'ընտրել {column}',
          columns: 'Ընտրել դաշտերը',
        },
      },
    }
  },
  validations() {
      const rules = {
        realBeneficiaries: {
          $each: {
            name_surname: { required },
            armenian_card_number: {
              requiredIf: requiredUnless((item) => item.international_card_number !== '')
            },
            international_card_number: {
              requiredIf: requiredUnless((item) =>  item.armenian_card_number !== '')
            },
          }
        }
      }

      if(this.procedure_type !== 'ELAH'){
        rules.selectedRows = {
          required,
          $each: {
            value: { required },
            vat: { required },
            overall: { required },
          }
        }
      }else{
        rules.selectedRows = {
          $each: {
            value: {},
            vat: {},
            overall: {},
          }
        }
      }

      if(this.realBeneficiaries.inputOptions === '1' && this.tender.is_new_beneficiari === true){
        rules.realBeneficiaries = {
          linkInfoPage: { required },
        }
      }else{
        rules.realBeneficiaries = {
          linkInfoPage: {},
        }
      }
      return rules;
  },
  computed: {
    me() {
      return this.$store.getters['user/me']
    },
  },
  methods: {
    nameWithViewId ({ viewId, name }) {
      return `${viewId} | ${name}`
    },
    getSubmittedDocumentData(data){
      this.submittedDocumentData = data
    },
    checkOption(){
      if(this.realBeneficiaries.inputOptions === '1'){
        this.showElem = true
        this.secondOption = true
        this.firstOption = false
      }
      if(this.realBeneficiaries.inputOptions === '2'){
        this.showElem = false
        this.secondOption = false
        this.firstOption = true
      }
    },
    consoleLog(data){
      console.log(data)
    },
    handleIsWithProductsDetails(){
      this.isConfirmed = false;
      if(!this.isWithProductsDetails){
        this.selectedRows.forEach(row => {
          row.value = '';
          row.vat = '';
          row.overall = '';
          row.cost = '';
          row.profit = '';
        });
        if(this.tender.is_old){
          this.columns = ['id', 'name', 'code', 'products_details', 'cost', 'profit', 'vat', 'overall', 'estimated_price'];
        } else {
          this.columns = ['id', 'name', 'code', 'products_details', 'price', 'vat', 'overall', 'estimated_price'];
        }
      } else {
        this.selectedRows.forEach(row => {
          row.firm_name = '';
          row.trademark = '';
          row.brand = '';
          row.manufacturer = '';
          row.specification = '';
          row.guarantee_time = '';
        });
        if(this.tender.is_old){
          this.columns = ['id', 'name', 'code', 'cost', 'profit', 'vat', 'overall', 'estimated_price'];
        } else {
          this.columns = ['id', 'name', 'code', 'price', 'vat', 'overall', 'estimated_price'];
        }
      }
    },
    beforeClose(){
      this.showElem = true
      this.items.realBeneficiaries = this.realBeneficiaries
      this.items.selectedRows = this.selectedRows
      this.items.workersCount = this.workersCount
      this.items.isWithArmenianResources = this.isWithArmenianResources
      this.items.submittedDocumentData = this.submittedDocumentData
      this.items.isConfirmed = this.isConfirmed

      const content = JSON.stringify(this.items);
      this.$client.post(`applications/set/${this.tender.id}`, {content}).then((value) => {
      })

      this.isConfirmed = false;
      this.workersCount = 0;
      this.isWithArmenianResources = false;
      this.tender = {};
      this.selectedRows = [];
      this.realBeneficiaries = {
          inputOptions: 1,
          linkInfoPage: '',
          name_surname: '',
          armenian_card_number: '',
          international_card_number: '',
      }
    },
    async beforeOpen({params}){
      this.showElem = true
      if(this.from === 'favoriteTenders'){
        this.fromFavorites = true;
      }

      this.addToFavorite = params.addToFavorite
      this.tender = params
      this.procedure_type = this.tender.procedure_type
      const optionIndex = this.columns.findIndex(item => item === 'products_details')
      this.tender.rows.forEach((row, index) => {
        const obj = {...row, viewId: index + 1, usedMaterials: [{name: '', count: '', value: ''}]}
        this.$set( this.tender.rows, index, obj)
      })
      const now = new Date();
      const string = now.toLocaleTimeString()
      const date = new Date()
      const dateString = new Date(date.getTime() - (date.getTimezoneOffset() * 60000 ))
                    .toISOString()
                    .split("T")[0]

      const comparedates = function(date1,date2){
          if (date1 > date2) return true;
        else return false; 
      }

      this.showBlock = comparedates(new Date(this.tender.finish_date), new Date(dateString + ' ' + string))

      if(optionIndex > 0){
        this.columns.splice(optionIndex, 1)
      }
      if(this.tender.cpv_type !== 'service'){
        if(this.tender.is_old){
          if(this.me.package === 'Գոլդ'){
            this.columns = ['id', 'name', 'code', 'products_details', 'cost', 'profit', 'vat', 'overall', 'estimated_price'];
          } else {
            this.columns = ['id', 'name', 'code', 'products_details', 'cost', 'profit', 'vat', 'overall'];
          }
        } else {
          if(this.me.package === 'Գոլդ'){
            this.columns = ['id', 'name', 'code', 'products_details', 'price', 'vat', 'overall', 'estimated_price'];
          } else {
            this.columns = ['id', 'name', 'code', 'products_details', 'price', 'vat', 'overall'];
          }
        }
      }else {
        if(this.tender.is_old){
          if(this.me.package === 'Գոլդ'){
            this.columns = ['id', 'name', 'code', 'cost', 'profit', 'vat', 'overall', 'estimated_price'];
          } else {
            this.columns = ['id', 'name', 'code', 'cost', 'profit', 'vat', 'overall'];
          }
        } else {
          if(this.me.package === 'Գոլդ'){
            this.columns = ['id', 'name', 'code', 'price', 'vat', 'overall', 'estimated_price'];
          } else {
            this.columns = ['id', 'name', 'code', 'price', 'vat', 'overall'];
          }
        }
      }
      if(this.is_old){
        await this.$client.get('real-beneficiaries').then(({data}) => {
          if(data.length){
            this.realBeneficiaries = [...data]
          }
        })
      }
      this.$client.get(`applications/get/${this.tender.id}`).then(({data}) => {
        if(data){
          const applications = JSON.parse(data.content);
          if(applications){
            this.realBeneficiaries = applications.realBeneficiaries;
            this.selectedRows = applications.selectedRows;
            this.workersCount = applications.workersCount;
            this.isWithArmenianResources = applications.isWithArmenianResources;
            this.submittedDocumentData = applications.submittedDocumentData
            this.isConfirmed = applications.isConfirmed
          }
        } else {
          const applications = JSON.parse(localStorage.getItem('applications'));
          if(applications){
            this.realBeneficiaries = applications[this.me.id][this.tender.id].realBeneficiaries;
            this.selectedRows = applications[this.me.id][this.tender.id].selectedRows;
            this.workersCount = applications[this.me.id][this.tender.id].workersCount;
            this.isWithArmenianResources = applications[this.me.id][this.tender.id].isWithArmenianResources;
          }
        }
        this.checkOption()
      })
      if(this.realBeneficiaries.inputOptions === '1'){
        this.showElem = true
        this.secondOption = true
        this.firstOption = false
      }else if(this.realBeneficiaries.inputOptions === '2'){
        this.showElem = false
        this.secondOption = false
        this.firstOption = true
      }else{
        this.secondOption = false
        this.firstOption = false
      }
    },
    addBeneficiary(){
      this.isConfirmed = false;
      this.realBeneficiaries.push({
        inputOptions: 1,
        linkInfoPage:'',
        name_surname: '',
        armenian_card_number: '',
        international_card_number: '',
      })
    },
    addUsedMaterial(rowIndex){
      this.isConfirmed = false;
      this.selectedRows[rowIndex].usedMaterials.push({
        name: '',
        count: '',
        value: '',
      })
    },
    removeBeneficiary(index){
      this.realBeneficiaries.splice(index, 1)
    },
    removeUsedMaterial(rowIndex, materialIndex){
      this.selectedRows[rowIndex].usedMaterials.splice(materialIndex, 1)
    },
    calculateByTotal(row, index) {
      const lot = row
      lot.vat = lot.is_with_vat && lot.value ? Number((lot.value * 0.2).toFixed(2)) : 0
      lot.overall = lot.value ? lot.value + lot.vat : 0
      this.$set(this.selectedRows, index, lot)
    },
    handleNameChange(row, index) {
        this.$set(this.selectedRows, index, row)
    },
    calculateByCost(row, index) {
      const lot = row
      if(+lot.cost && +lot.profit){
        lot.value = +lot.cost + +lot.profit;
        lot.vat = lot.is_with_vat && lot.value ? Number((lot.value * 0.2).toFixed(2)) : 0
        lot.overall = lot.value ? lot.value + lot.vat : 0
        this.$set(this.selectedRows, index, lot)
      }
    },
    calculateByVat(row, index) {
      const lot = row
      lot.overall = lot.is_with_vat ? lot.value + lot.vat : lot.value
      this.$set(this.selectedRows, index, lot)
    },
    handleVatSelect(row, index) {
      this.calculateByTotal(row, index)
    },
    setProductDetails(row, index){
      this.$set(this.selectedRows, index, row)
    },
    confirm(){
      this.selectedRows = this.selectedRows.sort((a,b) => (a.viewId > b.viewId) ? 1 : ((b.viewId > a.viewId) ? -1 : 0))
      const scrollingElement = (document.getElementById('modal-body'));
      scrollingElement.scrollTop = scrollingElement.scrollHeight;
      if(this.tender.is_new_beneficiari === false){
        if(!this.$v.realBeneficiaries.$invalid){
          if(!this.$v.selectedRows.$invalid){
            this.isConfirmed = true;
            this.addToFavorite(this.tender.id)
            // this.realBeneficiaries.forEach((value) => {
            //   if(!value.id){
            //     this.$client.post('real-beneficiaries', value)
            //   }
            // })
          } else {
            this.isConfirmed = false;
            this.$notify({
              group: 'foo',
              type: 'error',
              text: 'Լրացրեք չափաբաժինների բոլոր դաշտերը!'
            })
          }
        } else {
          this.isConfirmed = false;
          this.$notify({
            group: 'foo',
            type: 'error',
            text: 'Լրացրեք իրական շահառուների անհրաժեշտ դաշտերը!'
          })
        }
      }else{
        if(!this.$v.realBeneficiaries.$invalid){
          if(!this.$v.selectedRows.$invalid){
            this.isConfirmed = true;
            this.addToFavorite(this.tender.id)
            // this.realBeneficiaries.forEach((value) => {
            //   if(!value.id){
            //     this.$client.post('real-beneficiaries', value)
            //   }
            // })
          }else{
            this.isConfirmed = false;
            this.$notify({
              group: 'foo',
              type: 'error',
              text: 'Լրացրեք չափաբաժինների բոլոր դաշտերը!'
            })
          }
        }else{
          this.isConfirmed = false;
          this.$notify({
            group: 'foo',
            type: 'error',
            text: 'Լրացրեք տեղեկություններ պարունակող կայքէջի հղումը!'
          })
        }
      }
    },
    async save(){
      if(!this.$v.realBeneficiaries.$invalid){
        if(!this.$v.selectedRows.$invalid){
        } else {
          this.$notify({
            group: 'foo',
            type: 'error',
            text: 'Լրացրեք չափաբաժինների բոլոր դաշտերը!'
          })
        }
      } else {
        this.$notify({
          group: 'foo',
          type: 'error',
          text: 'Լրացրեք տեղեկություններ պարունակող կայքէջի հղումը!'
        })
      }
      await this.$store.dispatch('suggestions/update', {id: this.currSuggestionId, data: { is_signature: 1 }}).then(async (response) => {
        if(response) {
          await this.checkEqualPrice();
        }
      }).catch(e => {
        this.$notify({
          group: 'foo',
          type: 'error',
          title: 'Ինչ որ բան այն չէ',
          text: 'Կրկին փորձեք!'
        })
      })
    },
  },
}
</script>
<style scoped>
  /deep/ .vm--modal {
    top: 0 !important;
    bottom: 0 !important;
    right: 0 !important;;
    left: 0 !important;;
    margin: auto;
    position: absolute;
    overflow: inherit !important;
    width: 80%;
    /* height: auto !important; */
    padding-bottom: 0px;
    -webkit-border-radius: .3rem !important;
    -moz-border-radius: .3rem !important;
    border-radius: .3rem !important;
  }
  .searchItem:hover {
    background-color: #1e7bb7;
    color: #fff;
  }
  .component-fade-enter-active, .component-fade-leave-active {
    transition: opacity .2s ease;
  }
  .component-fade-enter, .component-fade-leave-to
    /* .component-fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .d_flex{
    display: flex;
  }
  .input-st{
    border: 1px solid #1e7bb7;
    border-radius: 2px;
    padding: 5px 10px;
    width: 100%;
  }
  .input-sp{
    margin-top: 4px;
  }
</style>

